import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiService } from "../api/apiService";

export const fetchUsers = createAsyncThunk(
    'users/fetchUsers',
    async (_, { rejectWithValue }) => {
        try {
            const users = await apiService.getUsers();
            return users;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
)

export const createUsers = createAsyncThunk(
    'users/createUsers',
    async (userData, { rejectWithValue }) => {
        try {
            const newUser = await apiService.createUser(userData);
            return newUser;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
)

export const fetchUserById = createAsyncThunk(
    'users/fetchUserById',
    async (userId, { rejectWithValue }) => {
        try {
            const user = await apiService.getUserById(userId);
            return user;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
)

const initialState = {
    users: [],
    selectedUser: null,
    loading: false,
    error: null,
    lastFetch: null
}

const userSlice = createSlice({
    name: "users",
    initialState,
    reducers: {
        clearError: (state) => {
            state.error = null;
        },
        setSelectedUser: (state, action) => {
            state.selectedUser = action.payload;
        },
        clearSelectedUser: (state) => {
            state.selectedUser = null;
        }
    },

    extraReducers: (builder) => {
        builder

            //penidng case
            .addCase(fetchUsers.pending, (state) => {
                state.loading = true;
                state.error = null
            })

            // fulfilled case
            .addCase(fetchUsers.fulfilled, (state, action) => {
                state.loading = false;
                state.users = action.payload
                state.lastFetch = new Date().toISOString();
            })

            //rejected case
            .addCase(fetchUsers.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload
            })

            //+++++++++++++++++++++++++++++++++++++++++++++++++ cases for create users +++++++++++++++++++++++++++++++++++++++++++++++++

            //penidng case
            .addCase(createUsers.pending, (state) => {
                state.loading = true;
                state.error = null
            })

            // fulfilled case
            .addCase(createUsers.fulfilled, (state, action) => {
                state.loading = false;
                state.users.push(action.payload)
            })

            //rejected case
            .addCase(createUsers.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload
            })

    }
})

export const { clearError, setSelectedUser, clearSelectedUser } = userSlice.actions
export default userSlice.reducer;  //export the reducer